//CORE
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
//OBSERVABLE
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
//MODEL
import { DidacticObject } from '../model/didactic_object';
import { LessonDetail } from '../model/lesson_detail';
import { ModalInfo } from '../model/modal_info';
import { environment } from '../../environments/environment';
import {CourseLesson} from "../model/course_lesson";
import {ModalScorm} from "../model/modal_scorm";


@Injectable()
export class CoursePageService {

    constructor(private http: Http) {
        this.http = http;
    }

    // ritorna la lista delle lezioni di un corso
    getLessons(course_id: number, key: string, user_id: number): Observable<CourseLesson[]> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({ headers: headers });
        return this.http.get(environment.base_url + 'Rest_Single_Lesson/all_course_lessons/user_id/' + user_id + '/id_course/' + course_id, options)
            .map((response: Response) => response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    // prendi i dettagli di una lezione
    getLessonDetail(user_id: number, course_id: number, lesson_id: number, key: string): Observable<LessonDetail> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({ headers: headers });
        return this.http.get(environment.base_url + 'Rest_Single_Lesson/single_lesson/user_id/' + user_id + '/id_course/' + course_id + '/id_lesson/' + lesson_id, options)
            .map((response: Response) => <any>response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    // ritorna la lista di tutti i Didactic Object di una lezione
    getOdLesson(user_id: number, course_id: number, lesson_id: number, key: string): Observable<DidacticObject[]> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({ headers: headers });
        return this.http.get(environment.base_url + 'Rest_Single_Lesson/od_lesson/user_id/' + user_id + '/id_course/' + course_id + '/id_lesson/' + lesson_id, options)
            .map((response: Response) => response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    // prendi le informazioni di un Didactic Object
    getModalOdInfo(course_id: number, user_id: number, od_id: number, key: string): Observable<ModalInfo> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({ headers: headers });
        return this.http.get(environment.base_url + 'Rest_Single_Lesson/single_od_info/id_course/' + course_id + '/user_id/' + user_id + '/id_od/' + od_id, options)
            .map((response: Response) => <ModalInfo>response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    // ritorna le informazioni di un corso dopo essere stato terminato
    getModalAfterComplete(user_id: number, course_id: number, od_id: number, score: number, key: string): Observable<ModalScorm> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({ headers: headers });
        return this.http.get(environment.base_url + 'Rest_Scorm/after_complete/user_id/' + user_id + '/id_course/' + course_id + '/idOD/' + od_id + '/score/' + score, options)
            .map((response: Response) => response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    getLegend(course_id: number, key: string): Observable<JSON> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({ headers: headers });
        return this.http.get(environment.base_url + 'Rest_Single_Lesson/do_typologies/id_course/' + course_id, options)
            .map((response: Response) => response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    getSingleLetterGlossary(letter: string, course_id: number, key: string): Observable<JSON> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({ headers: headers });
        return this.http.get(environment.base_url + 'Rest_Glossary/single_letter/id_course/' + course_id + '/char/' + letter, options)
            .map((response: Response) => response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/course-page.service.ts